export enum ReportDeliveryStatus {
    PHAT_THANH_CONG = 2,
    DON_HANG_SU_CO = 3,
    CHUYEN_HOAN = 4,
    HOAN_THANH_CONG = 5,
    PHAT_LAI = 6
}
